var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("TutorDashboardScheduleInfo"),
      _vm._v(" "),
      _c("TutorDashboardScheduleCalendar"),
      _vm._v(" "),
      _c("TutorDashboardScheduleLegend"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }